import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    Image,
    StyleSheet,
    ScrollView
} from 'react-native';

import {
    JDText
} from '@jdreact/jdreact-core-lib';
import { get } from '../common/fetch';
import { utils } from '@ltfe/ltfe-core-lib';
import NoMore from '../components/common/no-more';
import netImg from '../common/netImg';
const img = require('../common/img');
import NavBar from "../components/nav-bar";
import sgmReport from '../common/sgmUtil';

const { pt } = utils;

class Activity extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            info: null
        };
    }

    render() {
        const { info } = this.state;
        return (
            <View style={ st.context }>
                <ScrollView bounces={ false } stickyHeaderIndices={ [0] } >
                    <View style={ st.img_view }>
                        <Image style={ st.image } source={ { uri: netImg.banner } } />
                    </View>
                    <View style={ st.list }>

                        {info?.length > 0
                            ? info.map((val, index) => {
                                return (
                                    <View style={ st.scale_view } key={ index + '' }>
                                        <View style={ st.title_view }>
                                            <View>
                                                <JDText style={ st.title }>{val.title}</JDText>
                                            </View>
                                            <View>
                                                <JDText style={ st.title_msg }>{val.limitTitle}</JDText>
                                            </View>
                                        </View>
                                        <View style={ st.scale_txt }>
                                            <View>
                                                {
                                                    val.promtDetails.map((txt, index) => {
                                                        return (
                                                            <JDText key={ index + '' } style={ st.scale_list_txt }>{index + 1}. {txt}</JDText>
                                                        );
                                                    })
                                                }
                                                <JDText style={ st.scale_list_txt }>{val.promtDetails.length + 1}. 下单时如果不符合活动规则，将按原价进行下单；</JDText>
                                                <JDText style={ st.scale_list_txt }>{val.promtDetails.length + 2}. 在参加活动过程中，如果出现作弊行为（如批量注册、恶意购买、虚假交易等），京东电影票将自动取消该用户本次活动的相关订单，并有权取消您后续参与京东电影票任意活动的权利，必要时追究相关法律责任；</JDText>
                                            </View>
                                        </View>
                                    </View>

                                );
                            })
                            : <NoMore img={ img.no_list } txt='暂无相关促销信息' />
                        }
                    </View>

                </ScrollView>

            </View>
        );
    }

    componentDidMount() {
        this.getInfo();
    }

    getInfo() {
        const { ruleIds } = this.props;

        if(!ruleIds){
            sgmReport('1001', {function_id: 'getIssuePromtVO',message:'缺少参数ruleIds'}, 3)
        }

        get('getIssuePromtVO', {
		        ruleIds: ruleIds ? ruleIds.split(',') : []
        }, true).then((res) => {
            this.setState({
                info: res?.data?.list
            });
        }).catch(() => {
        });


    }
}

Activity.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    context: {
        flex: 1
    },
    list: {
        justifyContent: 'center',
        padding: pt(10),
        backgroundColor: '#fff'
    },
    scale_view: {
        // marginBottom: pt(15),
        borderColor: '#f1f1f1',
        borderWidth: pt(1),
        marginBottom: pt(10)
    },
    title_view: {
        borderColor: '#f1f1f1',
        borderBottomWidth: pt(1),
        padding: pt(15),
        backgroundColor: '#fff'
        // backgroundColor: '#F56f00',
        // backgroundColor: '#fffaf6',
    },
    title: {
        fontSize: pt(16),
        color: '#000',
        marginBottom: pt(8)
    },
    title_msg: {
        fontSize: pt(12),
        color: '#444'
    },
    scale_txt: {
        paddingVertical: pt(10),
        paddingHorizontal: pt(15),
        backgroundColor: '#fff'
    },
    scale_list_txt: {
        color: '#898989',
        fontSize: pt(12),
        marginBottom: pt(7)
    },
    img_view: {
        width: pt(375),
        height: pt(145)

    },
    image: {
        width: '100%',
        height: '100%',
        // backgroundColor: '#ccc',
        marginBottom: pt(8),
        resizeMode: 'contain'
    }
});

export default Activity;
